import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class contentPresetView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , type: ko.observable("")
            , isActive: ko.observable(false)
            , itemName: ko.observable("")
            , onClickEditContentPreset: function (data, event) {
                self.onClickEditContentPreset(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`


            <div class="w-form w-form-large">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: itemName"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditContentPreset }" class="btn icon i-edit"  type="button">Edit Content Preset</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Is Active</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isActive"></span>
                                </dd>
                                <dt>
                                    <span>Type</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: type"></span>
                                </dd>
                             
                                <dt>
                                    <span>Item Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: itemName"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                    <div class="form-body">
                    </div>
                </div>
        `);
    }

    protected setContentPresetData(contentpreset) {
        this.getTemplateViewModel().id(contentpreset.id)
        this.getTemplateViewModel().type(contentpreset.type)
        this.getTemplateViewModel().isActive(contentpreset.isActive)
        this.getTemplateViewModel().itemName(contentpreset.itemName)
    }

    protected getTemplateName(): string {
        return "contentPresetView_template";
    }

    protected onClickEditContentPreset(id: any): any {
        this.caller.onClickEditContentPreset(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/contentPresetView_template.ts